<template>
  <paper class="fine">
    <m-pane
      ref="tablePage"
      :config="config"
      :totalData="totalData"
      :pageTotal="pageTotal"
      :searchTotalTitle="config.searchTotalTitle"
      :loading="loading"
      :currentPage="currentPage"
      searchId="fine11"
      pageID="fine"
      @row-db-click="rowDBclick"
      @selectChange="selectChange"
      @searchChange="searchChange"
      @pageChange="pageChange"
      @sizeChange="sizeChange"
    >
      <div slot="table-module-btn">
        <el-tooltip effect="dark" content="导出" placement="bottom">
          <span class="mgl-10">
            <el-button
              v-has="'07010001'"
              icon="el-icon-download"
              size="mini"
              :loading="isHeadExport"
              @click="exportFile"
            ></el-button>
          </span>
        </el-tooltip>
      </div>
    </m-pane>
  </paper>
</template>

<script>
import { getFineTasks, exportLoadHeaders } from '../../../api/cost.js';
import mPane from '@/components/supplierPanel';
import paper from '@/components/core/paper/Paper';
import config from './config.js';
import formatTime from '@/utils/common.js';
import bigDataLog from '@/utils/bigDataLog';
export default {
    name: 'fineIndex',
    components: { mPane, paper },
    data() {
        return {
            selected: [],
            searchDataLists: {},
            dataObj: {},
            currentPage: 1,
            selectData: [],
            searchObj: {
                pageNo: 1,
                pageSize: 10
            },
            pageTotal: 0,
            totalData: [],
            loading: false,
            isHeadExport: false,
            config
        };
    },
    methods: {
        getFineTasks() {
            this.$refs.tablePage.$refs.searchList.changeLoading(true);
            this.loading = true;
            const temp = { pageNo: this.searchObj.pageNo, pageSize: this.searchObj.pageSize, ...this.searchDataLists };
            this.currentPage = this.searchObj.pageNo;
            getFineTasks(temp).then(res => {
                this.loading = false;
                this.$refs.tablePage.$refs.searchList.changeLoading(false);
                if (res.code === '0' && res) {
                    this.totalData = res.data.list;
                    for (var i = 0; i < this.totalData.length; i++) {
                        this.totalData[i].status = this.totalData[i].status.toString();
                        this.totalData[i].operationType = this.totalData[i].operationType.toString();
                    }
                    this.pageTotal = res.data.totalCount;
                }
            });
        },
        rowDBclick(row) {
            if (row.supFineNo) {
                bigDataLog.sendDetailMessage({
                    model_name1: '财务结算',
                    model_name2: '罚扣款核对',
                    model_name3: '',
                    model_name4: '双击进入详情'
                });
                this.$router.push({ query: { supFineNo: row.supFineNo, jobid: row.jobId }, path: `/bms/fineDetails` });
            } else {
                return this.$message.warning('没有对应的单据编号，不允许查询数据详情');
            }
        },
        pageChange(data) {
            this.searchObj.pageNo = data;
            this.getFineTasks();
        },
        sizeChange(data) {
            this.currentPage = 1;
            this.searchObj.pageSize = data;
            this.searchObj.pageNo = 1;
            this.getFineTasks();
        },
        searchChange(data) {
            this.searchObj.pageNo = 1;
            data = this.formattingData(data);
            this.searchDataLists = data;
            this.getFineTasks();
        },
        formattingData(data) {
            const tempData = {
                createTimeFrom: data.createTime ? formatTime.formatDate(data.createTime[0]) + ' 00:00:00' : '',
                createTimeTo: data.createTime ? formatTime.formatDate(data.createTime[1]) + ' 23:59:59' : '',
                ...data
            };
            delete tempData.createTime;
            return tempData;
        },
        selectChange(data) {
            data.forEach(item => {
                this.supFineNo = item.supFineNo;
            });
            this.selected = [].concat(data);
        },
        exportFile() {
            const supFineNos = [];
            this.selected.map(item => { item.supFineNo && supFineNos.push(item.supFineNo); });
            this.isHeadExport = true;
            const params = { ...this.searchDataLists };
            exportLoadHeaders(params).then(res => {
                const blob = new Blob([res], {
                    type: 'application/x-excel;charset=UTF-8'
                });
                const objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = objectUrl;
                a.download = '罚扣款核对.xlsx';
                a.click();
                document.body.removeChild(a);
            }).finally(() => { this.isHeadExport = false; });
        }
    },
    mounted() {
        this.$refs.tablePage.$refs.searchList.onSearchChange();
    }
};
</script>

<style lang="less"></style>
